import script from "./MallOrderPackMark.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallOrderPackMark.vue?vue&type=script&setup=true&lang=ts"

import "./MallOrderPackMark.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__